import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Divider, Form, Input, Row, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useWindowSize } from '@/hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';

const defaultEmptyFieldError = {
  required: true,
  message: <FormattedMessage id="commons.form.errors.requiredField" />,
};

const validEmailFieldError = {
  type: 'email',
  message: <FormattedMessage id="commons.form.errors.invalidEmail" />,
};

const PersonalDataForm = ({ initialValues, onSubmit }) => {
  const { width } = useWindowSize();

  
  return (
  <>
    <Row>
      <Col span={24} md={24}>
        <Typography.Title level={width < 576 ? 5 : 4} style={{margin: '20px 0px'}}>
          <FormattedMessage id="settings.account.title" />
        </Typography.Title>

        <Divider />

        <Typography.Title level={width < 576 ? 5 : 4} style={{ margin: '12px 0px' }}>
          <FormattedMessage id="settings.account.personalData" />
        </Typography.Title>

        <Form
          layout="vertical"
          onFinish={onSubmit}
          style={{ padding: '8px 0' }}
          initialValues={{
            email: initialValues?.email,
            login: initialValues?.login,
          }}
        >
          <Form.Item
            name="email"
            label={
              <FormattedMessage id="settings.account.personalData.email" />
            }
            rules={[defaultEmptyFieldError, validEmailFieldError]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            name="login"
            label={<FormattedMessage id="settings.account.accessData.login" />}
            rules={[defaultEmptyFieldError]}
          >
            <Input />
          </Form.Item>

          <SpaceForButton>
            <Button block type="primary" htmlType="submit">
              <FormattedMessage id="settings.account.personalData.submit" />
            </Button>
          </SpaceForButton>
        </Form>
        <Divider />
      </Col>
    </Row>
  </>
)};

PersonalDataForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default PersonalDataForm;
